<template>
  <section class="invoice-preview-wrapper">
    <b-row class="invoice-preview">

      <!-- LISTADO DE ESPECIALIDADES Y BUSCADOR -->
      <b-col
        cols="12"
      >
        <b-overlay
          :show="loader"
          rounded="sm"
        >

          <b-row class="mb-2">
            <b-col
              cols="12"
              xl="6"
            >
              <!-- BUSCADOR DE OFERTA ACADÉMICA -->
              <buscador-oferta
                :result-size="data.length"
                class="mb-2"
                @newSearch="seachString = $event"
              />

            </b-col>

            <b-col
              cols="12"
              xl="6"
            >
              <filtro-nivel-academico @item-selected="filtroNivel = $event" />

            </b-col>
          </b-row>
          <!-- LISTADO DE ESPECIALIDADES -->
          <grid-view :data="data" />
        </b-overlay>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  VBPopover,
  BOverlay,
} from 'bootstrap-vue'
import { onMounted, ref, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import gridView from './components/views-oferta/grid-view.vue'
import buscadorOferta from './components/buscador-oferta/buscador-oferta.vue'
import filtroNivelAcademico from './components/filtro-nivel-academico/filtro-nivel-academico.vue'

export default {
  components: {
    gridView,
    BRow,
    BCol,
    BOverlay,

    filtroNivelAcademico,
    buscadorOferta,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  setup() {
    const toast = useToast()
    const seachString = ref('')
    const filtroNivel = ref(null)
    const loader = ref(false)

    const fetchData = async () => {
      try {
        loader.value = true
        await store.dispatch('ofertaAcademica/loadOferta')
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en solicitud [oferta académica]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
      } finally {
        loader.value = false
      }
    }

    const data = computed(() => store.getters['ofertaAcademica/getPlanesEstudio']({ search: seachString.value, nivel: filtroNivel.value }))

    onMounted(() => {
      fetchData()
    })

    return {
      loader,
      seachString,
      filtroNivel,
      data,
    }
  },
}
</script>
